import React from 'react';
import { Flex, Typography, theme } from 'antd';
import { ArrowRightOutlined } from '@ant-design/icons';

type ArrowLinkProps = {
  href: string;
  label: string;
  onClick?: () => void;
  fontSize?: number;
};

// The AI Insights link style: a green arrow followed by the label, opening in a
// new tab. Used by the page header's "Learn more" link and the fix-tip
// documentation links, so the two stay visually identical.
function ArrowLink({ href, label, onClick, fontSize }: ArrowLinkProps) {
  const { token } = theme.useToken();

  return (
    <Typography.Link
      href={href}
      target="_blank"
      rel="noreferrer"
      onClick={onClick}
      style={{ color: token.colorPrimary, ...(fontSize !== undefined && { fontSize }) }}
    >
      <Flex gap={token.marginXXS} align="center">
        {/* antd sets aria-label="arrow-right" on every icon; without aria-hidden a
        screen reader announces the icon name as part of the link's name. */}
        <ArrowRightOutlined aria-hidden />
        {label}
      </Flex>
    </Typography.Link>
  );
}

export default ArrowLink;
